"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = submitSendBox;
exports.SUBMIT_SEND_BOX = void 0;
var SUBMIT_SEND_BOX = 'WEB_CHAT/SUBMIT_SEND_BOX';
exports.SUBMIT_SEND_BOX = SUBMIT_SEND_BOX;

function submitSendBox() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'keyboard';

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      channelData = _ref.channelData;

  return {
    type: SUBMIT_SEND_BOX,
    payload: {
      channelData: channelData,
      method: method
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N1Ym1pdFNlbmRCb3guanMiXSwibmFtZXMiOlsiU1VCTUlUX1NFTkRfQk9YIiwic3VibWl0U2VuZEJveCIsIm1ldGhvZCIsImNoYW5uZWxEYXRhIiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxlQUFlLEdBQUcsMEJBQXhCOzs7QUFFZSxTQUFTQyxhQUFULEdBQWtFO0FBQUEsTUFBM0NDLE1BQTJDLHVFQUFsQyxVQUFrQzs7QUFBQSxpRkFBSixFQUFJO0FBQUEsTUFBcEJDLFdBQW9CLFFBQXBCQSxXQUFvQjs7QUFDL0UsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVKLGVBREQ7QUFFTEssSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLFdBQVcsRUFBWEEsV0FBRjtBQUFlRCxNQUFBQSxNQUFNLEVBQU5BO0FBQWY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTVUJNSVRfU0VORF9CT1ggPSAnV0VCX0NIQVQvU1VCTUlUX1NFTkRfQk9YJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3VibWl0U2VuZEJveChtZXRob2QgPSAna2V5Ym9hcmQnLCB7IGNoYW5uZWxEYXRhIH0gPSB7fSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNVQk1JVF9TRU5EX0JPWCxcbiAgICBwYXlsb2FkOiB7IGNoYW5uZWxEYXRhLCBtZXRob2QgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTVUJNSVRfU0VORF9CT1ggfTtcbiJdfQ==